module.exports = __webpack_public_path__ + "img/amenidades5.5fb914af.png";